import { getDatestamp } from './analytics.getters';
import { TodayCounter } from './analytics.schema';

// Increment a today's counter stored on replicant
export function incrementTodayCounter(
  purchaseTime: number,
  counter: TodayCounter,
  count: number = 1,
): void {
  const datestamp = getDatestamp(purchaseTime);

  if (datestamp > counter.datestamp) {
    counter.datestamp = datestamp;
    counter.count = count;
  } else {
    counter.count += count;
  }
}

// Initialize a today's counter
export function initTodayCounter(
  purchaseTime: number,
  count: number = 1,
): { count: number; datestamp: number } {
  const datestamp = getDatestamp(purchaseTime);

  const newCounter: TodayCounter = {
    datestamp: datestamp,
    count: count,
  };

  return newCounter;
}
